import styled, { css, withTheme, ThemeProvider } from 'styled-components';
import { createElement, Children, useRef, useState, useCallback, useEffect, Fragment } from 'react';
import { debounce } from 'lodash-es';

var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/**
 * Converts device breakpoints to tagged template literals that can be used as media queries
 * @param breakpoints - A dictionary of device breakpoints, representing a value `w` (measured in `px`). Any width `x` that falls in the range `0 <= x <= w` will have the css defined in the media query applied.
 */
var createMediaQueryTemplate = function (breakpoints) {
    return Object.keys(breakpoints).reduce(function (acc, label) {
        acc[label] = function (literals) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "], ["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "])), breakpoints[label], css.apply(void 0, [literals].concat(args)));
        };
        return acc;
    }, {});
};
var templateObject_1;

var __makeTemplateObject$1 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawButton = styled.button(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject$1(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"], ["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"])));
var UnstyledButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, children = _a.children, className = _a.className, variant = _a.variant, disabled = _a.disabled, pressed = _a.pressed, onKeyDown = _a.onKeyDown, expanded = _a.expanded;
    return (createElement(RawButton, { onClick: onClick, className: className, variant: variant, disabled: disabled, "aria-pressed": pressed, "aria-expanded": expanded, onKeyDown: onKeyDown }, children));
};
var index = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest(_a, ["theme"]);
    return (createElement(theme.button, __assign({}, rest)));
});
var templateObject_1$1;

var __makeTemplateObject$2 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawCard = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject$2(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
var UnstyledCard = function (_a) {
    var className = _a.className, children = _a.children, variant = _a.variant;
    return (createElement(RawCard, { className: className, variant: variant }, children));
};
var index$1 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$1(_a, ["theme"]);
    return (createElement(theme.card, __assign$1({}, rest)));
});
var templateObject_1$2;

var __makeTemplateObject$3 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/**
 * Wrapper for the Carousel
 */
var CarouselContainer = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject$3(["\n  height: 150px;\n  max-width: 70vw;\n  width: 60vw;\n  overflow: hidden;\n  margin: auto;\n  position: relative;\n"], ["\n  height: 150px;\n  max-width: 70vw;\n  width: 60vw;\n  overflow: hidden;\n  margin: auto;\n  position: relative;\n"])));
/**
 * Scrolling track element for the Carousel
 */
var CarouselTrack = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject$3(["\n  display: flex;\n  position: absolute;\n  ", "\n  width: calc(", ");\n\n  &:hover {\n    animation-play-state: paused;\n  }\n\n  animation: scroll ", "\n    linear infinite;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes scroll {\n    100% {\n      transform: translateX(", "50%);\n    }\n  }\n"], ["\n  display: flex;\n  position: absolute;\n  ", "\n  width: calc(", ");\n\n  &:hover {\n    animation-play-state: paused;\n  }\n\n  animation: scroll ", "\n    linear infinite;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes scroll {\n    100% {\n      transform: translateX(",
    "50%);\n    }\n  }\n"])), function (props) { return (props.direction === "right" ? "right: 0;" : "left: 0;"); }, function (props) { return props.itemWidth * props.count; }, function (props) { return (props.duration ? props.duration + "s" : "25s"); }, function (props) {
    return props.direction === "left" ? "-" : "";
});
var UnstyledCarousel = function (_a) {
    var className = _a.className, _b = _a.direction, direction = _b === void 0 ? "left" : _b, itemWidth = _a.itemWidth, duration = _a.duration, children = _a.children;
    return (createElement(CarouselContainer, { className: className },
        createElement(CarouselTrack, { itemWidth: itemWidth, direction: direction, count: Children.count(children), duration: duration }, children)));
};
var index$2 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$2(_a, ["theme"]);
    return (createElement(theme.carousel, __assign$2({}, rest)));
});
var templateObject_1$3, templateObject_2;

var __makeTemplateObject$4 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
var __rest$3 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var IndicatorContainer = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject$4(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var IndicatorDot = styled.li(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject$4(["\n  list-style: none;\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 100%;\n  background: rgba(196, 196, 196, 0.5);\n\n  &.active {\n    background: #000000;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  list-style: none;\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 100%;\n  background: rgba(196, 196, 196, 0.5);\n\n  &.active {\n    background: #000000;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Indicator = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$3(_a, ["theme"]);
    return createElement(theme.indicator, __assign$3({}, rest));
});
var UnstyledIndicator = function (_a) {
    var className = _a.className, isActive = _a.isActive, onClick = _a.onClick;
    return (createElement(IndicatorDot, { className: isActive ? className + " active" : className, onClick: onClick }));
};
var getIndicators = function (themed, count, currentIndex, onClick) {
    var dots = [];
    var _loop_1 = function (i) {
        dots.push(themed ? (createElement(Indicator, { key: "indicator-" + i, onClick: function () { return onClick(i); }, isActive: currentIndex === i })) : (createElement(UnstyledIndicator, { key: "indicator-" + i, onClick: function () { return onClick(i); }, isActive: currentIndex === i })));
    };
    for (var i = 0; i < count; i++) {
        _loop_1(i);
    }
    return (createElement(IndicatorContainer, { className: "indicator__container" }, dots));
};
var templateObject_1$4, templateObject_2$1;

var __makeTemplateObject$5 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$4 = (undefined && undefined.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
var __rest$4 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var GalleryContainer = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject$5(["\n  overflow: hidden;\n  width: 500px;\n"], ["\n  overflow: hidden;\n  width: 500px;\n"])));
/**
 * Container for the gallery items and where animations will be applied. Can be styled via class of `gallery__slider`
 */
var GallerySlider = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject$5(["\n  display: flex;\n  margin-bottom: 20px;\n"], ["\n  display: flex;\n  margin-bottom: 20px;\n"])));
var UnstyledGallery = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.duration, duration = _b === void 0 ? 200 : _b, _c = _a.threshold, threshold = _c === void 0 ? 20 : _c, _d = _a.easing, easing = _d === void 0 ? "ease-out" : _d, _e = _a.perPage, perPage = _e === void 0 ? 1 : _e, _f = _a.startIndex, startIndex = _f === void 0 ? 0 : _f, _g = _a.draggable, draggable = _g === void 0 ? false : _g, _h = _a.loop, loop = _h === void 0 ? false : _h, _j = _a.resizeDebounce, resizeDebounce = _j === void 0 ? 250 : _j, _k = _a.showIndicators, showIndicators = _k === void 0 ? true : _k, _l = _a.autoScroll, autoScroll = _l === void 0 ? false : _l, _m = _a.autoScrollInterval, autoScrollInterval = _m === void 0 ? 4000 : _m, _o = _a.useThemedIndicators, useThemedIndicators = _o === void 0 ? false : _o, _p = _a.onInit, onInit = _p === void 0 ? function () { } : _p, _q = _a.onChange, onChange = _q === void 0 ? function () { } : _q;
    var galleryRef = useRef(null);
    var sliderRef = useRef(null);
    var _r = useState(startIndex), currentItem = _r[0], setCurrentItem = _r[1];
    var _s = useState(0), galleryWidth = _s[0], setWidth = _s[1];
    var _t = useState(false), dragged = _t[0], setDragged = _t[1]; // flag for dirty (dragged/scrolled) gallery
    var indices = useRef({ from: null, to: null });
    var isDown = false;
    var drag = draggable
        ? {
            startX: 0,
            endX: 0,
            startY: 0,
            letGo: null
        }
        : null;
    var innerElements = useRef(null);
    // slides to the currently focused item
    var slideToCurrent = useCallback(function () {
        sliderRef.current.style["transform"] = "translate3d(-" + Math.round(currentItem * (galleryWidth / perPage)) + "px, 0, 0)";
    }, [currentItem, galleryWidth, perPage, sliderRef]);
    // resets drag properties
    var clearDrag = function () {
        drag = {
            startX: 0,
            endX: 0,
            startY: 0,
            letGo: null
        };
    };
    var updateIndices = useCallback(function (nextIndex) {
        indices.current = { from: currentItem, to: nextIndex };
        setCurrentItem(nextIndex);
    }, [currentItem]);
    // go to the previous item in the gallery
    var prev = function (n, onPrevCompleted) {
        if (n === void 0) { n = 1; }
        if (onPrevCompleted === void 0) { onPrevCompleted = function () { return []; }; }
        if (currentItem === 0 && loop) {
            updateIndices(innerElements.current.length - perPage);
        }
        else {
            updateIndices(Math.max(currentItem - Number(n), 0));
        }
        slideToCurrent();
        // call callbacks
        onChange(indices.current);
        onPrevCompleted();
    };
    // go to the next item in the gallery
    var next = useCallback(function (n, onNextCompleted) {
        if (n === void 0) { n = 1; }
        if (onNextCompleted === void 0) { onNextCompleted = function () { return []; }; }
        if (currentItem === innerElements.current.length - perPage && loop) {
            updateIndices(0);
        }
        else {
            updateIndices(Math.min(currentItem + Number(n), innerElements.current.length - perPage));
        }
        slideToCurrent();
        // call callbacks
        onChange(indices.current);
        onNextCompleted();
    }, [currentItem, loop, onChange, perPage, slideToCurrent, updateIndices]);
    // triggers transition between items after a drag is detected
    var updateAfterDrag = function () {
        var movement = drag.endX - drag.startX;
        if (movement > 0 && Math.abs(movement) > threshold) {
            prev();
        }
        else if (movement < 0 && Math.abs(movement) > threshold) {
            next();
        }
        slideToCurrent();
        setDragged(true);
    };
    // sets CSS properties for transitions
    var setStyle = function (target, styles) {
        Object.keys(styles).forEach(function (attribute) {
            target.style[attribute] = styles[attribute];
        });
    };
    // reset transition params for slides with eases
    var resetTransitionStyles = function () {
        setStyle(sliderRef.current, {
            cursor: "grab",
            transition: "all " + duration + "ms " + easing
        });
    };
    // translate the items according to the mouse/touch movements
    var setDraggingStyles = function () {
        setStyle(sliderRef.current, {
            transition: "all 0ms " + easing,
            transform: "translate3d(" + (currentItem * (galleryWidth / perPage) +
                (drag.startX - drag.endX)) *
                -1 + "px, 0, 0)"
        });
    };
    var onTouchStart = function (e) {
        e.stopPropagation();
        isDown = true;
        drag.startX = e.touches[0].pageX;
        drag.startY = e.touches[0].pageY;
    };
    var onTouchEnd = function (e) {
        e.stopPropagation();
        isDown = false;
        setStyle(sliderRef.current, {
            transition: "all " + duration + "ms " + easing
        });
        if (drag.endX) {
            updateAfterDrag();
        }
        clearDrag();
    };
    var onTouchMove = function (e) {
        e.stopPropagation();
        if (drag.letGo === null) {
            drag.letGo =
                Math.abs(drag.startY - e.touches[0].pageY) <
                    Math.abs(drag.startX - e.touches[0].pageX);
        }
        if (isDown && drag.letGo) {
            drag.endX = e.touches[0].pageX;
            setDraggingStyles();
        }
    };
    var onMouseDown = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isDown = true;
        drag.startX = e.pageX;
        // set the cursor to the grabbing during the drag
        setStyle(sliderRef.current, {
            cursor: "grabbing"
        });
    };
    var onMouseUp = function (e) {
        e.stopPropagation();
        isDown = false;
        resetTransitionStyles();
        if (drag.endX) {
            updateAfterDrag();
        }
        clearDrag();
    };
    var onMouseMove = function (e) {
        e.preventDefault();
        if (isDown) {
            drag.endX = e.pageX;
            setDraggingStyles();
        }
    };
    var onMouseLeave = function (e) {
        if (isDown) {
            isDown = false;
            drag.endX = e.pageX;
            resetTransitionStyles();
            updateAfterDrag();
            clearDrag();
        }
    };
    // go to a specified item in the gallery
    var goTo = function (index) {
        updateIndices(Math.min(Math.max(index, 0), innerElements.current.length - 1));
        slideToCurrent();
        onChange(indices.current);
    };
    // callback for a window resize event; resizes gallery
    var resize = useCallback(function () {
        setWidth(galleryRef.current.getBoundingClientRect().width);
        setStyle(sliderRef.current, {
            width: (galleryWidth / perPage) * innerElements.current.length + "px"
        });
    }, [galleryWidth, perPage]);
    var debouncedResize = debounce(function () {
        resize();
        slideToCurrent();
    }, resizeDebounce);
    // autoscrolling side effects
    useEffect(function () {
        var interval;
        if (autoScroll) {
            interval = setInterval(function () {
                next();
                slideToCurrent();
            }, autoScrollInterval);
        }
        return function () {
            clearInterval(interval);
        };
    }, [autoScroll, autoScrollInterval, next, slideToCurrent]);
    // setup width and resize handlers
    useEffect(function () {
        if (dragged) {
            slideToCurrent(); // just slide to the next item if it's been initialized
        }
        else if (sliderRef.current) {
            // save the children in a ref
            innerElements.current = [].slice.call(sliderRef.current.children);
            // set width of the gallery
            setWidth(galleryRef.current.getBoundingClientRect().width);
            if (galleryWidth) {
                setStyle(sliderRef.current, {
                    cursor: "grab",
                    width: (galleryWidth / perPage) * innerElements.current.length + "px",
                    transition: "all " + duration + "ms " + easing
                });
                innerElements.current.forEach(function (element) {
                    setStyle(element, {
                        width: 100 / innerElements.current.length + "%"
                    });
                });
                window.addEventListener("resize", debouncedResize);
                slideToCurrent();
                onInit();
            }
        }
        return function () {
            window.removeEventListener("resize", debouncedResize);
        };
    }, [
        currentItem,
        debouncedResize,
        dragged,
        duration,
        easing,
        galleryWidth,
        isDown,
        onChange,
        onInit,
        perPage,
        resize,
        resizeDebounce,
        slideToCurrent,
        startIndex,
        updateIndices
    ]);
    var eventHandlers = draggable
        ? {
            onTouchStart: onTouchStart,
            onTouchEnd: onTouchEnd,
            onTouchMove: onTouchMove,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            onMouseLeave: onMouseLeave
        }
        : {};
    return (createElement(GalleryContainer, __assign$4({ className: className, ref: galleryRef }, eventHandlers),
        createElement(GallerySlider, { className: "gallery__slider", ref: sliderRef }, children),
        showIndicators &&
            innerElements.current &&
            getIndicators(useThemedIndicators, innerElements.current.length, currentItem, goTo)));
};
var index$3 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$4(_a, ["theme"]);
    return createElement(theme.gallery, __assign$4({ useThemedIndicators: true }, rest));
});
var templateObject_1$5, templateObject_2$2;

var __makeTemplateObject$6 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$5 = (undefined && undefined.__assign) || function () {
    __assign$5 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};
var __rest$5 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawLink = styled.a(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject$6(["\n  color: inherit;\n  text-decoration: none;\n"], ["\n  color: inherit;\n  text-decoration: none;\n"])));
var UnstyledLink = function (_a) {
    var children = _a.children, _b = _a.newTab, newTab = _b === void 0 ? false : _b, _c = _a.download, download = _c === void 0 ? false : _c, url = _a.href, className = _a.className;
    var target = newTab ? "_blank" : undefined;
    var rel = newTab ? "noopener noreferrer" : "";
    return (createElement(RawLink, { href: url, target: target, rel: rel, download: download, className: className }, children));
};
var index$4 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$5(_a, ["theme"]);
    return (createElement(theme.link, __assign$5({}, rest)));
});
var templateObject_1$6;

var __makeTemplateObject$7 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$6 = (undefined && undefined.__assign) || function () {
    __assign$6 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};
var __rest$6 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var Wrapper = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject$7(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
var UnstyledLoader = function (_a) {
    var className = _a.className, loading = _a.loading, render = _a.render;
    var getRender = function () {
        if (typeof render === "function") {
            return render();
        }
        else if (typeof render === "object") {
            return render;
        }
        else {
            /* eslint-disable no-console */
            console.error("render prop must be a single JSX element or a function callback");
        }
    };
    return createElement(Wrapper, { className: className }, loading && getRender());
};
var index$5 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$6(_a, ["theme"]);
    return (createElement(theme.loader, __assign$6({}, rest)));
});
var templateObject_1$7;

var __makeTemplateObject$8 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$7 = (undefined && undefined.__assign) || function () {
    __assign$7 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};
var __rest$7 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawText = styled.p(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject$8(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * The unstyled version of a `Text` component. This should only be used when defining a theme.
 */
var UnstyledText = function (_a) {
    var _b = _a.as, as = _b === void 0 ? "p" : _b, id = _a.id, className = _a.className, children = _a.children;
    return (createElement(RawText, { id: id, className: className, as: as }, children));
};
/**
 * A component for displaying text.
 */
var Text = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$7(_a, ["theme"]);
    return (createElement(theme.text, __assign$7({}, rest)));
});
var templateObject_1$8;

var __makeTemplateObject$9 = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$8 = (undefined && undefined.__assign) || function () {
    __assign$8 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};
var __rest$8 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawTextAreaInput = styled.textarea(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject$9(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * A multi-line `TextAreaInput` component, unstyled.
 */
var UnstyledTextAreaInput = function (_a) {
    var className = _a.className, defaultValue = _a.defaultValue, onChange = _a.onChange, placeholder = _a.placeholder, variant = _a.variant, value = _a.value, label = _a.label;
    return (createElement(RawTextAreaInput, { className: className, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, variant: variant, value: value, "aria-label": label }));
};
/**
 * A multi-line `TextAreaInput` component, withTheme.
 */
var index$6 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$8(_a, ["theme"]);
    return (createElement(theme.textAreaInput, __assign$8({}, rest)));
});
var templateObject_1$9;

var __makeTemplateObject$a = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$9 = (undefined && undefined.__assign) || function () {
    __assign$9 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};
var __rest$9 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var RawTextInput = styled.input(templateObject_1$a || (templateObject_1$a = __makeTemplateObject$a(["\n  /* stylelint-disable no-empty-block */\n"], ["\n  /* stylelint-disable no-empty-block */\n"])));
/**
 * A single-line `TextInput` component, unstyled.
 */
var UnstyledTextInput = function (_a) {
    var className = _a.className, defaultValue = _a.defaultValue, onChange = _a.onChange, placeholder = _a.placeholder, required = _a.required, type = _a.type, value = _a.value, variant = _a.variant, label = _a.label;
    return (createElement(RawTextInput, { className: className, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, required: required, type: type, value: value, variant: variant, "aria-label": label }));
};
/**
 * A single-line `TextInput` component, withTheme.
 */
var index$7 = withTheme(function (_a) {
    var theme = _a.theme, rest = __rest$9(_a, ["theme"]);
    return (createElement(theme.textInput, __assign$9({}, rest)));
});
var templateObject_1$a;

var __makeTemplateObject$b = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign$a = (undefined && undefined.__assign) || function () {
    __assign$a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};
/**
 * Converts a component definition to a styled component
 * @param componentDefinition - The component definition to convert
 * @param componentDefinition.component - The component to apply the variants to
 * @param componentDefinition.sharedStyles - Shared styles across all instances of the component
 * @param componentDefinition.variants - The variant styles to apply on the component
 */
var componentFromDefinition = function (_a) {
    var component = _a.component, sharedStyles = _a.sharedStyles, variants = _a.variants;
    return styled(component)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject$b(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ",
        "\n"])), sharedStyles, function (_a) {
        var variant = _a.variant;
        return typeof variant === "string" && variants && variants[variant];
    });
};
/**
 * Converts a theme definition to a theme
 * @param themeDefinition - The theme definition to convert to a theme
 */
var themeFromDefinition = function (themeDefinition) {
    // Creates a media query template literal function for each breakpoint
    var mediaQueries = themeDefinition.deviceBreakpoints &&
        createMediaQueryTemplate(themeDefinition.deviceBreakpoints);
    return {
        mediaQueries: mediaQueries,
        globalConstants: themeDefinition.globalConstants,
        // spreading user-defined ComponentDefinitions allows them to
        // overwrite the default UnstyledComponent if they have their own defined
        button: componentFromDefinition(__assign$a({ component: UnstyledButton }, (themeDefinition.button || {}))),
        card: componentFromDefinition(__assign$a({ component: UnstyledCard }, (themeDefinition.card || {}))),
        carousel: componentFromDefinition(__assign$a({ component: UnstyledCarousel }, (themeDefinition.carousel || {}))),
        gallery: componentFromDefinition(__assign$a({ component: UnstyledGallery }, (themeDefinition.gallery || {}))),
        indicator: componentFromDefinition(__assign$a({ component: UnstyledIndicator }, (themeDefinition.indicator || {}))),
        link: componentFromDefinition(__assign$a({ component: UnstyledLink }, (themeDefinition.link || {}))),
        loader: componentFromDefinition(__assign$a({ component: UnstyledLoader }, (themeDefinition.loader || {}))),
        text: componentFromDefinition(__assign$a({ component: UnstyledText }, (themeDefinition.text || {}))),
        textAreaInput: componentFromDefinition(__assign$a({ component: UnstyledTextAreaInput }, (themeDefinition.textAreaInput || {}))),
        textInput: componentFromDefinition(__assign$a({ component: UnstyledTextInput }, (themeDefinition.textInput || {})))
    };
};
var North = function (_a) {
    var themeDefinition = _a.themeDefinition, children = _a.children;
    var theme = themeFromDefinition(themeDefinition);
    return (createElement(ThemeProvider, { theme: theme },
        createElement(Fragment, null,
            themeDefinition.globalStyles && createElement(themeDefinition.globalStyles, null),
            children)));
};
var templateObject_1$b;

export { index as Button, index$1 as Card, index$2 as Carousel, index$3 as Gallery, GallerySlider, Indicator, index$4 as Link, index$5 as Loader, North, Text, index$6 as TextAreaInput, index$7 as TextInput, UnstyledButton, UnstyledCard, UnstyledCarousel, UnstyledGallery, UnstyledIndicator, UnstyledLink, UnstyledLoader, UnstyledText, UnstyledTextAreaInput, UnstyledTextInput, createMediaQueryTemplate, getIndicators };
